import { Message } from './message';

export class QueueMessage extends Message {
  Queue: string;
}
